export default {
  statuses: null,
  isLoading: false,
  errors: null,
};
